import { FC } from "react";
import bgImage from "../../Assets/homev2/vod-bg.png";

const TalentOnDemandTechCommunity: FC = () => {
    const columns = [
        [
            "Technology",
            "Engineering",
            "Executive",
            "Software Developers",
            "User Interface Design",
            "User Experience Design",
            "Application Developer",
            "Information Security Analyst",
            "Cloud Engineer",
            "Helpdesk technician",
        ],
        [
            "AI Specialists",
            "Data Experts",
            "Computer Network Architect",
            "Web Developer",
            "CTO",
            "Network Engineer",
            "Data analysis",
            "Product Manager",
            "DevOps Engineer",
            "Blockchain engineer",
        ],
        [
            "Database Administrator",
            "Machine Learning Engineer",
            "Data Science",
            "Cybersecurity",
            "Computer System Analyst",
            "Project Manager",
            "Business Intelligence",
            "Cybersecurity Manager",
            "IT Manager",
            "Platform Engineer",
        ],
    ];

    return (
        <section
            className="w-full bg-cover bg-no-repeat overflow-hidden py-20 px-6"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full max-w-[1400px] mx-auto flex flex-col items-center gap-10">
                <h2 className="text-2xl md:text-4xl lg:text-5xl text-black font-semibold text-center">
                    Our talent community is focused on the following functions:
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full mt-10 text-black">
                    {columns.map((col, index) => (
                        <div
                            key={index}
                            className={`flex flex-col lg:flex-row gap-3 px-4 mx-auto w-full justify-evenly`}
                        >
                            {
                                index !== 0 ? (
                                    <div className="lg:w-px lg:h-full w-full h-px bg-black opacity-20"></div>
                                ) : null
                            }
                            <div className="flex flex-col gap-3">
                                {col.map((item, i) => (
                                    <p key={i} className="text-lg font-semibold leading-relaxed before:content-['•'] before:mr-2">
                                        {item}
                                    </p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex flex-col md:flex-row mt-5 mx-auto gap-5">
                    <a
                        target="_blank"
                        href={"/talent-ondemand"}
                        className="bg-transparent mx-auto hover:bg-brand-green hover:text-white border border-black hover:border-brand-green text-black font-medium px-6 py-3 rounded-full transition-all duration-200"
                    >
                        Talent onDemand Overview
                    </a>
                    <a
                        target="_blank"
                        href={"/talent-ondemand/features"}
                        className="bg-transparent mx-auto hover:bg-brand-green hover:text-white border border-black hover:border-brand-green text-black font-medium px-6 py-3 rounded-full transition-all duration-200"
                    >
                        Talent onDemand Features
                    </a>
                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandTechCommunity;
